namespace Vit {
    export interface CombogridEditorOptions extends Serenity.ServiceLookupEditorOptions {
    }

    @Serenity.Decorators.registerEditor("Serenity.CombogridEditor")
    export class CombogridEditor<TOptions extends CombogridEditorOptions, TItem> extends Serenity.ServiceLookupEditorBase<TOptions, TItem> {
        private textField: string;

        constructor(hidden: JQuery, opt?: TOptions) {
            super(hidden, opt);

            if (!this.columns || !this.columns.length) {
                /* TODO: Exception */
                return;
            }

            this.setTextField();
            this.setIncludeColumns();
        }

        private setTextField(): void {
            this.options.textField = (this.columns as any).find((column: CombogridColumn) => column.primary)?.field ?? super.getTextField();
        }

        protected getColumns(): Array<CombogridColumn> {
            return [{
                name: "",
                field: "text",
                primary: true,
                visible: true,
            }];
        }

        private setIncludeColumns() {
            const includeCols = this.columns.filter(item => !!item.visible || !!item.primary);
            this.options.includeColumns = includeCols.map(item => item.field);
        }

        protected mapItem(item: any) {
            item.disabled = this.itemDisabled(item);
            item.source = item;

            return item;
        }

        protected getRemoteInit(): boolean {
            return false;
        }
    }
}